import AssignByCalories from './AssignByCalories';

export default AssignByCalories;
